export default {
  getVersionBack: state => state.back
};
